import Login from './Login';
import NotFound from './NotFound';
import Unauthorized from './Unauthorized';

export default {
	Login, 
	NotFound,
	Unauthorized
};